import { styled } from "styled-components";

export const BrandImageWrapper = styled.div`
  width: fit-content;
  height: fit-content;
`;
